import { render, staticRenderFns } from "./AdvertCard.vue?vue&type=template&id=4710f20c&scoped=true"
import script from "./AdvertCard.vue?vue&type=script&lang=js"
export * from "./AdvertCard.vue?vue&type=script&lang=js"
import style0 from "./AdvertCard.vue?vue&type=style&index=0&id=4710f20c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4710f20c",
  null
  
)

export default component.exports